export default __webpack_public_path__ + "assets/models/c9ce0b4c17d4aa66846625bd18717d09.glb";